import { typography, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Wrapper = styled.main`
  padding: 32px;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Title = styled.h1`
  ${typographyV2.titleLg};
  color: var(--text-default);
  margin: 0;
`;

export const Description = styled.p`
  ${typography.dingo};
  color: var(--text-soft);
  margin: 0;
`;

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

interface OptionProps {
  $isSelected: boolean;
}

export const Option = styled.button<OptionProps>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid
    ${({ $isSelected }) =>
      $isSelected ? 'var(--surface-primary)' : 'var(--border-default)'};
  background: ${({ $isSelected }) =>
    $isSelected
      ? 'rgba(var(--surface-primary-rgb), 0.08)'
      : 'var(--surface-default)'};
  cursor: pointer;
  text-align: left;
  transition: border-color 150ms ease, background 150ms ease;

  &:hover {
    border-color: var(--surface-primary);
  }
`;

export const OptionTitle = styled.span`
  ${typographyV2.titleSm};
  color: var(--text-default);
`;

export const OptionDescription = styled.span`
  ${typography.koala};
  color: var(--text-soft);
`;
